import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Row } from '@components/form/Form/Form';
import * as TextField from '@components/form/TextField/TextField';

type GroupSelectionSetsMergeFormProps = {
    setName: string;
    onSetNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onFormSubmit: (event: React.FormEvent<HTMLFormElement>) => Promise<void>;
    disabled?: boolean;
};

const GroupSelectionSetsMergeForm = memo(
    ({ setName, onSetNameChange, onFormSubmit, disabled }: GroupSelectionSetsMergeFormProps) => {
        const { t } = useTranslation();

        return (
            <Form
                name="group-selection-sets-list-form"
                onSubmit={onFormSubmit}
                submitBtnTitle={t('road-network.group-selection-save-set-submit-btn')}
                disabled={disabled}
            >
                <Row>
                    <TextField.Labeled
                        name="name"
                        type="text"
                        label={t('road-network.save-route-as-selection-set.selection-set-name')}
                        value={setName}
                        onChange={onSetNameChange}
                        required
                        autoFocus
                    />
                </Row>
            </Form>
        );
    }
);

export default GroupSelectionSetsMergeForm;
